import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    btn: {
      fontWeight: 500,
      maxWidth: 240,
      margin: '0 auto',
    },
    checkIcon: {
      color: theme.palette.success.main,
      fontSize: theme.typography.pxToRem(14),
      marginRight: 8,
    },
    or: {
      textTransform: 'uppercase',
      maxWidth: 240,
      width: '100%',
    },
  };
});

export default useStyles;
